import { IDropdownList } from "../tsmodels/SharedModel";

export const dropdownList:IDropdownList[] = [
    { id: 1, value: 'text' },
    { id: 2, value: 'Checkbox' },
    { id: 3, value: 'Radio' },
    { id: 4, value: 'Listbox' },
    { id: 5, value: 'Button' },
    { id: 6, value: 'Combo' },
    { id: 7, value: 'Unknown' },
  
  ];
